<template>
  <div class="cooperation-my-pay-change-cp-container">
    <div class="pay-text-container" @click="handDetail">
      <div class="pay-title-banner">
        <span class="left-title">{{ item.pactName }}</span>
      </div>
      <div class="pay-text-content">
        <span>所属公司：</span>
        <span>{{ item.theirCompany }}</span>
      </div>
      <div class="pay-text-content" v-if="item.approvestate.trim() != '已审核'">
        <span>申报日期：</span>
        <span>{{
          item.applyforDate && moment(item.applyforDate).format('YYYY-MM-DD')
        }}</span>
      </div>
    </div>
    <template v-if="item.approvestate.trim() == '已审核'">
      <div>
        <div class="date">
          <div>
            <span>申报日期：</span
            ><span>{{
              item.applyforDate &&
                moment(item.applyforDate).format('YYYY-MM-DD')
            }}</span>
          </div>
        </div>
        <div class="examined">
          <div>
            <span>{{ item.applyamount | money2 }}</span
            ><span>申报金额</span>
          </div>
          <div>
            <span>{{ item.bcinvoiceamount | money2 }}</span
            ><span>发票金额</span>
          </div>
          <div>
            <span style="color:#C18858">{{ item.bcljsfamount | money2 }}</span
            ><span>实际付款金额</span>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="no-examined">
        <div>
          <span>申报金额</span
          ><span style="color:#36C490">{{ item.applyamount | money2 }}</span>
        </div>
        <div>
          <span>发票金额</span
          ><span style="color:#36C490">{{ item.bcinvoiceamount | money2 }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import moment from 'moment';
import { getUrlParams } from 'common/js/mUtils';

export default {
  name: 'cooperation-my-pay-change-cp',

  data() {
    return {
      moment
    };
  },
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {},

  components: {},

  methods: {
    handDetail() {
      let { item } = this;
      let { contractguid } = item;
      let { employeeName, mobile } = getUrlParams();
      this.$router.push({
        name: 'cooperationDetail',
        query: {
          contractguid,
          index: 1,
          employeeName: decodeURIComponent(employeeName),
          mobile
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.cooperation-my-pay-change-cp-container {
  padding-bottom: 30px;
  .pay-text-container {
    padding: 20px;
    position: relative;
    .pay-title-banner {
      .left-title {
        width: 100%;
        color: #000000;
        font-size: 28px;
        display: inline-block;
        line-height: 1.5;
      }
      .right-icon {
        width: 120px;
        height: 40px;
        font-size: 22px;
        color: white;
        line-height: 40px;
        text-align: center;
        background: #36c490;
        display: inline-block;
        position: absolute;
        right: 0;
      }
    }
    .pay-text-content {
      font-size: 26px;
      margin-top: 10px;
      display: flex;
      span:nth-child(1) {
        width: 140px;
        display: inline-block;
        line-height: 1.5;
        color: #999;
      }
      span:nth-child(2) {
        flex: 1;
        line-height: 1.5;
        max-width: 100%;
        color: #666666;
      }
    }
  }
  .pay-banner {
    padding: 20px;
    .pay-title {
      height: 150px;
      background: rgba(239, 239, 239, 0.38);
      display: flex;
      width: 100%;
      padding: 20px;
      font-size: 24px;
      .left {
        width: 50%;
        height: 110px;
        border-right: 1px solid #efefef;
        overflow: hidden;
        padding-right: 30px;
        span {
          color: #000000;
          float: right;
        }
        p {
          margin-top: 15px;
          color: #666666;
        }
        p:nth-child(1) {
          margin-top: 0;
        }
      }
      .right {
        height: 110px;
        width: 50%;
        padding-left: 20px;
        overflow: hidden;
        // padding-right: 30px;
        span {
          color: #c18858;
          float: right;
        }
        p {
          margin-top: 15px;
        }
        p:nth-child(1) {
          margin-top: 0;
        }
      }
    }
  }
  .date {
    height: 40px;
    background: #efefef;
    margin: 0px 40px 20px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    div {
      display: flex;
      color: #666;
      font-size: 24px;
      padding: 0px 12px;
    }
  }
  .examined {
    display: flex;
    justify-content: space-around;
    text-align: center;
    div {
      display: flex;
      flex-direction: column;
      span:nth-child(1) {
        color: #000000;
        font-size: 26px;
        font-weight: 600;
      }
      span:nth-child(2) {
        color: #666;
        font-size: 24px;
        margin-top: 16px;
      }
    }
  }
  .no-examined {
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;
  }
}
</style>
